/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * why this repo requires a paid plan
 * @export
 * @enum {string}
 */
export enum BillingReason {
    PRIVATE = 'PRIVATE',
    ENTERPRISE = 'ENTERPRISE'
}

export function BillingReasonFromJSON(json: any): BillingReason {
    return BillingReasonFromJSONTyped(json, false);
}

export function BillingReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingReason {
    return json as BillingReason;
}

export function BillingReasonToJSON(value?: BillingReason | null): any {
    return value as any;
}

